// 3 exercices guidés multi-écritures : cas concrets d'entreprise sur plusieurs étapes.
// L'utilisateur passe chaque écriture, la correction et l'explication s'affichent étape par étape.

export const EXERCICES = [
  {
    id: "ex1",
    titre: "Création d'une SARL et premier exercice",
    contexte:
      "Vous créez la SARL « Atelier Bois », société de fabrication et vente de meubles en bois massif. Capital social 10 000 €, 2 associés à parts égales. Voici les 6 premières opérations à comptabiliser.",
    difficulte: "Débutant",
    duree: "15 min",
    couleur: "#EFF6FF",
    etapes: [
      {
        n: 1,
        enonce:
          "Constitution : les 2 associés versent ensemble 10 000 € de capital social sur le compte bancaire de la société.",
        solution: [
          { c: "512", l: "Banque", d: 10000, k: 0 },
          { c: "101", l: "Capital", d: 0, k: 10000 },
        ],
        explication:
          "Apport en numéraire libéré intégralement : la trésorerie augmente (débit 512), le capital social est constitué (crédit 101). Si seulement une partie était libérée, on aurait utilisé 1011/1012/1013 pour distinguer souscrit, appelé, versé.",
      },
      {
        n: 2,
        enonce:
          "Achat d'une scie professionnelle (machine industrielle) : 4 000 € HT, TVA 20 %, payable à 30 jours au fournisseur ProBois.",
        solution: [
          { c: "2154", l: "Matériels industriels", d: 4000, k: 0 },
          { c: "44562", l: "TVA déductible sur immobilisations", d: 800, k: 0 },
          { c: "404", l: "Fournisseurs d'immobilisations", d: 0, k: 4800 },
        ],
        explication:
          "Bien durable d'investissement → immobilisation au 2154 (machines industrielles). TVA spécifique en 44562 (immo, pas 44566). Dette envers le fournisseur d'immo au 404 (jamais 401 pour un investissement).",
      },
      {
        n: 3,
        enonce:
          "Achat de matières premières (bois brut) : 1 500 € HT + TVA 20 %, paiement immédiat par virement bancaire.",
        solution: [
          { c: "601", l: "Achats stockés – Matières premières", d: 1500, k: 0 },
          { c: "44566", l: "TVA déductible sur ABS", d: 300, k: 0 },
          { c: "512", l: "Banque", d: 0, k: 1800 },
        ],
        explication:
          "Le bois est une matière première incorporée au produit fini → 601 (et non 607 marchandises, ni 606 non stocké). TVA déductible classique sur ABS au 44566. Paiement immédiat = sortie de banque, pas de 401.",
      },
      {
        n: 4,
        enonce:
          "Vente du premier meuble fabriqué : facture client 2 400 € HT + TVA 20 %, payable à 30 jours.",
        solution: [
          { c: "411", l: "Clients", d: 2880, k: 0 },
          { c: "701", l: "Ventes de produits finis", d: 0, k: 2400 },
          { c: "44571", l: "TVA collectée", d: 0, k: 480 },
        ],
        explication:
          "Vente d'un produit fini fabriqué par l'entreprise → 701 (différent de 707 négoce et 706 prestations). Créance TTC sur le client au 411. TVA collectée 44571 qu'on devra reverser à l'État.",
      },
      {
        n: 5,
        enonce:
          "Paie du seul salarié de l'entreprise : salaire brut 2 000 €, cotisations salariales 400 €. Net à payer 1 600 €.",
        solution: [
          { c: "641", l: "Rémunérations du personnel", d: 2000, k: 0 },
          { c: "421", l: "Personnel – Rémunérations dues", d: 0, k: 1600 },
          { c: "431", l: "Sécurité sociale", d: 0, k: 400 },
        ],
        explication:
          "On comptabilise toujours le BRUT en charge (641), puis on l'éclate entre net dû au salarié (421) et cotisations salariales précomptées (431). Ne pas oublier d'ajouter les charges patronales dans une écriture suivante (645 contre 431).",
      },
      {
        n: 6,
        enonce:
          "Déclaration de TVA du premier mois : TVA collectée 480 €, TVA déductible 1 100 € (300 ABS + 800 immo). Quel est le solde ?",
        solution: [
          { c: "44571", l: "TVA collectée", d: 480, k: 0 },
          { c: "44567", l: "Crédit de TVA à reporter", d: 620, k: 0 },
          { c: "44566", l: "TVA déductible sur ABS", d: 0, k: 300 },
          { c: "44562", l: "TVA déductible sur immobilisations", d: 0, k: 800 },
        ],
        explication:
          "Déductible (1 100) > Collectée (480) → on a un crédit de TVA de 620 € à reporter ou à se faire rembourser. On utilise 44567 (créance sur l'État) et non 44551 (qui n'est utilisé que quand on doit payer).",
      },
    ],
  },
  {
    id: "ex2",
    titre: "Cycle d'achat-vente et règlements",
    contexte:
      "L'entreprise « Distri+ » est un négociant en équipements de bureau. Elle achète des photocopieurs en gros et les revend aux PME. Comptabilisez le cycle complet d'une opération.",
    difficulte: "Intermédiaire",
    duree: "12 min",
    couleur: "#ECFDF5",
    etapes: [
      {
        n: 1,
        enonce:
          "Réception facture fournisseur : 10 photocopieurs à 500 € HT pièce = 5 000 € HT, TVA 20 %.",
        solution: [
          { c: "607", l: "Achats de marchandises", d: 5000, k: 0 },
          { c: "44566", l: "TVA déductible sur ABS", d: 1000, k: 0 },
          { c: "401", l: "Fournisseurs", d: 0, k: 6000 },
        ],
        explication:
          "Marchandises destinées à la revente en l'état → 607 (et non 601 matières premières). Fournisseur d'exploitation classique → 401.",
      },
      {
        n: 2,
        enonce:
          "Vente de 4 photocopieurs au client PME-Sud : 800 € HT pièce = 3 200 € HT, TVA 20 %, paiement à 30 jours.",
        solution: [
          { c: "411", l: "Clients", d: 3840, k: 0 },
          { c: "707", l: "Ventes de marchandises", d: 0, k: 3200 },
          { c: "44571", l: "TVA collectée", d: 0, k: 640 },
        ],
        explication:
          "Revente en l'état → 707 (et non 706 prestations). Le client paie le TTC, donc 411 est à 3 840 €.",
      },
      {
        n: 3,
        enonce:
          "Le fournisseur accorde un escompte commercial de 2 % (= 100 €) pour règlement comptant. Émission d'un avoir de 100 € HT + 20 € TVA. Règlement immédiat du solde (5 880 €).",
        solution: [
          { c: "401", l: "Fournisseurs", d: 5880, k: 0 },
          { c: "765", l: "Escomptes obtenus", d: 0, k: 100 },
          { c: "44566", l: "TVA déductible sur ABS (régul.)", d: 0, k: 20 },
          { c: "512", l: "Banque", d: 0, k: 5760 },
        ],
        explication:
          "Un escompte financier obtenu pour règlement rapide est un produit financier (765). On régularise la TVA déductible au passage. Total débit = 5 880 (solde fournisseur), total crédit = 100 (escompte) + 20 (TVA) + 5 760 (banque) = 5 880.",
      },
      {
        n: 4,
        enonce:
          "Le client PME-Sud règle sa facture par virement bancaire 30 jours plus tard.",
        solution: [
          { c: "512", l: "Banque", d: 3840, k: 0 },
          { c: "411", l: "Clients", d: 0, k: 3840 },
        ],
        explication:
          "Encaissement classique : on solde la créance 411 par le débit de 512. Pas de TVA ici (déjà constatée à la facturation).",
      },
      {
        n: 5,
        enonce:
          "À la clôture annuelle, il reste en stock 6 photocopieurs (valeur 3 000 €). Le stock initial était de 0. Constatez la variation de stock de marchandises.",
        solution: [
          { c: "37", l: "Stocks de marchandises", d: 3000, k: 0 },
          { c: "6037", l: "Variation des stocks de marchandises", d: 0, k: 3000 },
        ],
        explication:
          "En inventaire intermittent, on n'enregistre le stock final qu'à la clôture. Le compte 6037 (variation, classe 6) vient diminuer la charge d'achat de 607 (puisqu'on a stocké, on n'a pas tout consommé).",
      },
    ],
  },
  {
    id: "ex3",
    titre: "Clôture annuelle : ajustements et résultat",
    contexte:
      "À la clôture du 31/12/N, vous devez passer les écritures de régularisation classiques pour l'entreprise « Boutique Sophie ». Voici les ajustements à comptabiliser.",
    difficulte: "Avancé",
    duree: "18 min",
    couleur: "#FFF7ED",
    etapes: [
      {
        n: 1,
        enonce:
          "Facture EDF de décembre N estimée à 600 € HT (TVA 20 %), non reçue à la clôture. Rattachez la charge à l'exercice N.",
        solution: [
          { c: "6061", l: "Fournitures non stockables – Énergie", d: 600, k: 0 },
          { c: "44586", l: "TVA sur factures non parvenues", d: 120, k: 0 },
          { c: "408", l: "Fournisseurs – Factures non parvenues", d: 0, k: 720 },
        ],
        explication:
          "Charge engagée en N mais facture non reçue → rattachement par 408 (factures non parvenues, dette estimée). TVA en 44586 (compte spécifique). À contre-passer le 01/01/N+1.",
      },
      {
        n: 2,
        enonce:
          "Loyer payé d'avance le 15/12/N pour janvier-février-mars N+1 : 3 000 € HT. Régularisez la part non consommée en N.",
        solution: [
          { c: "486", l: "Charges constatées d'avance", d: 3000, k: 0 },
          { c: "6132", l: "Locations immobilières", d: 0, k: 3000 },
        ],
        explication:
          "On retire de N la part qui appartient à N+1. 486 (CCA) est un compte d'actif transitoire qui sera contre-passé le 01/01/N+1 pour remettre la charge en N+1.",
      },
      {
        n: 3,
        enonce:
          "Une créance client de 2 400 € TTC (2 000 HT + 400 TVA) est devenue douteuse (procédure collective ouverte). Reclassement et dépréciation à 60 % du HT.",
        solution: [
          { c: "416", l: "Clients douteux ou litigieux", d: 2400, k: 0 },
          { c: "411", l: "Clients", d: 0, k: 2400 },
          { c: "68174", l: "Dotations pour dépréciation des créances", d: 1200, k: 0 },
          { c: "491", l: "Dépréciation des comptes de clients", d: 0, k: 1200 },
        ],
        explication:
          "Étape 1 : on reclasse la créance TTC du 411 vers 416 (douteux). Étape 2 : dépréciation calculée sur le HT (2 000 × 60 % = 1 200 €) car la TVA est récupérable en cas de perte définitive. Charge 68174 contre passif correctif 491.",
      },
      {
        n: 4,
        enonce:
          "Dotation aux amortissements annuelle d'un véhicule utilitaire de 12 000 € amorti linéairement sur 5 ans.",
        solution: [
          { c: "6811", l: "Dotations aux amortissements – Immo corporelles", d: 2400, k: 0 },
          { c: "28182", l: "Amortissements du matériel de transport", d: 0, k: 2400 },
        ],
        explication:
          "12 000 / 5 = 2 400 €/an. Charge 6811 (classe 6, dans le compte de résultat) contre 28182 (compte correctif d'actif, sous 2182). La valeur nette du véhicule au bilan = 12 000 – 2 400 = 9 600 € en fin de N1.",
      },
      {
        n: 5,
        enonce:
          "Provision pour congés payés : il reste 15 jours de CP non pris à la clôture, valorisés à 4 500 € + 1 800 € de charges patronales.",
        solution: [
          { c: "6412", l: "Congés payés", d: 4500, k: 0 },
          { c: "6451", l: "Cotisations URSSAF", d: 1800, k: 0 },
          { c: "4287", l: "Personnel – Dettes provisionnées CP", d: 0, k: 4500 },
          { c: "4382", l: "Charges sociales sur CP à payer", d: 0, k: 1800 },
        ],
        explication:
          "Les CP acquis non pris à la clôture sont une dette envers les salariés (4287) et envers l'URSSAF pour les charges associées (4382). À contre-passer en N+1 quand les CP seront effectivement payés.",
      },
    ],
  },
];
